import { render, staticRenderFns } from "./brand-detail-v2.vue?vue&type=template&id=6e8f094a&scoped=true"
import script from "./brand-detail-v2.vue?vue&type=script&lang=js"
export * from "./brand-detail-v2.vue?vue&type=script&lang=js"
import style0 from "./brand-detail-v2.vue?vue&type=style&index=0&id=6e8f094a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8f094a",
  null
  
)

export default component.exports